import { OrderItemState } from '../types/order-item-state';

export class SetOrderItemState {
    public orderItemID: Number;
    public orderItemState: OrderItemState;
}
